/**
 * Dashboard
 * Copyright 2021. All Rights Reserved
 * Created By: BC
 */
import "babel-polyfill";
import Vue from "vue";
import Vuetify from "vuetify";
import * as VueGoogleMaps from "vue2-google-maps";
// import { Vue2Dragula } from 'vue2-dragula';
import VueQuillEditor from "vue-quill-editor";
import wysiwyg from "vue-wysiwyg";
import VueBreadcrumbs from "vue2-breadcrumbs";
import VueResource from "vue-resource";
import Notifications from "vue-notification";
import velocity from "velocity-animate";
import AmCharts from "amcharts3";
import AmSerial from "amcharts3/amcharts/serial";
import AmAngularGauge from "amcharts3/amcharts/gauge";
import VueI18n from "vue-i18n";
import VueTour from "vue-tour";
import fullscreen from "vue-fullscreen";
import InstantSearch, { TreeMenu } from "vue-instantsearch";
import VueVideoPlayer from "vue-video-player";
import Croppa from "vue-croppa";
import VueCookies from "vue-cookies";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import Widgets from "fusioncharts/fusioncharts.widgets";
import PowerCharts from "fusioncharts/fusioncharts.powercharts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import Sortable from "sortablejs";
import VueSignaturePad from "vue-signature-pad";

// import VueCookies from "vue-cookies-reactive";

// import Highcharts from 'highcharts'
import HighchartsVue from "highcharts-vue";

// global components
import GlobalComponents from "System/globalComponents";

// application components
import ApplicationComponents from "Application/applicationComponents";

// app.vue
import App from "./App";

// router
import router from "Router";

// themes
import primaryTheme from "Themes/primaryTheme";

// mixins
import mixin from "Mixin/mixin";
// store
import { store } from "Store/store";
import { mapGetters, mapState } from "vuex";

// firebase
//import './firebase'

// include script file
import "Lib/VuelyScript";

// include all css files
import "Lib/VuelyCss";

// messages
import messages from "Lang";

// printing
import VueHtml2Canvas from "vue-html2canvas";
import _ from "lodash";
import AppConfig from "Constants/AppConfig";
import globalFunctions from "System/globalFunctions";
import applicationFunctions from "Application/applicationFunctions";
import { getCurrentUser } from "Core/users/config/api.users";
import { get } from "jquery";
// navigator.serviceWorker.register("./service-worker.js");

// encode url
function encode($data) {
    let encodedPath = btoa($data);
    // console.log('in encode', $data, encodedPath);
    encodedPath = encodedPath.replace(/=+$/, "");
    encodedPath = encodedPath.replace("+/", "-");
    encodedPath = encodedPath.trimEnd();
    return encodedPath; //strtr(rtrim(base64encode($data), '='), '+/', '-');
}

// navigation guards before each
router.beforeEach((to, from, next) => {
    if (to.matched && to.matched.length > 0) {
        // check if path is defined in routes
        if (to.matched.some((record) => record.meta.requiresAuth)) {
            // this route requires auth, check if logged in
            // if not, redirect to login page.
            let current_date = new Date();
            let cookie_date = $cookies.isKey("token") ? new Date($cookies.get("token").token_expires) : new Date();
            if (!$cookies.isKey("token") || current_date > cookie_date) {
                store.dispatch("logoutUser");

                let correctPath = from.params.id ? from.fullPath : to.fullPath;
                correctPath = correctPath.endsWith("/") ? correctPath.slice(0, -1) : correctPath;
                let encodedPath = encode(correctPath);
                next({
                    path: "/session/login" + (encodedPath && encodedPath.length > 0 && correctPath != "/home" ? "/" + encodedPath : ""),
                });
            } else {
                // const today = new Date();
                // const aprilFirst = new Date(today.getFullYear(), 3, 1);
                // let user_ids = [];
                // let random_num = Math.floor(Math.random() * (50 - 1 + 1) + 1);

                // let mainDiv = $("body");
                // if (
                //     random_num % 2 == 0 &&
                //     today.getMonth() === aprilFirst.getMonth() &&
                //     today.getDate() === aprilFirst.getDate() &&
                //     user_ids.includes(store.state.auth.current_user.user_id)
                // ) {
                //     mainDiv.css("transform", "rotate(185deg)");
                //     mainDiv.css("opacity", "60%");
                // } else {
                //     mainDiv.css("transform", "");
                //     mainDiv.css("opacity", "");
                // }
                // check login type, if employee, display either employee menu or specified menu if given in metadata
                // if customer, check if url is a restricted path and redirect to dashboard if it is
                // otherwise display customer menu or specified menu if given in metadata

                store.dispatch("checkCurrentuser");

                // let token = $cookies.get("token");
                // // Check the token.token_expires date and if it is less than the current date, set the token_expires to right now
                // if (token && token.token_expires) {
                //     let token_expires = new Date(token.token_expires);
                //     let now = new Date();
                //     let difference = token_expires - now;
                //     $cookies.set("token", { token: token.token, token_expires: new Date(token_expires.getTime() + difference) });
                // }

                if (to.meta.restrict_by_login_type && !to.meta.restrict_by_login_type.includes(store.state.auth.current_user.slug)) {
                    console.log("You do not have access to this page because you are the user type: " + store.state.auth.current_user.slug);
                    next({ name: "dashboard", replace: true });
                    return;
                }

                if (to.meta.restrict_by_permission && !to.meta.restrict_by_permission.every((perm) => store.state.auth.current_user.global.includes(perm))) {
                    console.log("You do not have access to this page because you missing the permission: " + to.meta.restrict_by_permission);
                    next({ name: "dashboard", replace: true });
                    return;
                }

                // use 'loader' value from route meta / params or default true otherwise
                // meta used to set loader on a per route level, param used on a per push level
                if ((to.meta.loader === undefined || !!to.meta.loader) && (to.params.loader === undefined || !!to.params.loader)) {
                    //store.commit("startLoader"); // only start loader if good path
                    store.dispatch("showLoader");
                }

                const personHasLoginType = (person = null, login_type = null) => {
                    if (login_type && person && person.slug) {
                        return login_type.includes(person.slug);
                    }
                };

                if (to.meta.menu) {
                    store.commit("setMenu", to.meta.menu);
                } else if (personHasLoginType(store.state.auth.current_user, ["customer_support", "employee", "administrator", "developer"])) {
                    store.commit("setMenu", store.getters.employeeMenu);
                } else if (personHasLoginType(store.state.auth.current_user, ["d_acct_mgr", "distributor"])) {
                    store.commit("setMenu", store.getters.distributorMenu);
                } else {
                    store.commit("setMenu", store.getters.customerMenu);
                }
                // MAKE SURE PROTOCOL IS HTTPS
                if (document.location.protocol !== "https:") {
                    next({ path: `https:${location.href.substring(location.protocol.length)}` });
                } else if (to.fullPath.endsWith("/")) {
                    next({ path: to.fullPath.slice(0, -1) });
                } else {
                    next(); // make sure to always call next()!
                }
            }
        } else {
            if (to.path === from.path || (to.path == "/session/login" && from.params && from.params.redirect)) {
                // if redirecting with query added or redirect param included then abort
                next(false);
            } else {
                if (to.fullPath.endsWith("/")) {
                    next({ path: to.fullPath.slice(0, -1) });
                } else {
                    next(); // make sure to always call next()!
                }
            }
        }
    } else {
        // default back to dashboard if bad route
        next({ name: "dashboard", replace: true });
    }
});

// navigation guard after each
router.afterEach((to, from) => {
    store.commit("validationOff");
    setTimeout(() => {
        const contentWrapper = document.querySelector(".v-content__wrap");
        if (contentWrapper !== null) {
            contentWrapper.scrollTop = 0;
        }
        const boxedLayout = document.querySelector(".app-boxed-layout .app-content");
        if (boxedLayout !== null) {
            boxedLayout.scrollTop = 0;
        }
        const miniLayout = document.querySelector(".app-mini-layout .app-content");
        if (miniLayout !== null) {
            miniLayout.scrollTop = 0;
        }
    }, 200);
    localStorage.setItem("lastRoute", from.fullPath);
});

// plugins
Vue.use(VueHtml2Canvas);
Vue.use(Vuetify, {
    theme: store.getters.selectedTheme.theme,
});
Vue.use(InstantSearch);
Vue.use(VueI18n);
Vue.use(AmCharts);
Vue.use(AmSerial);
Vue.use(VueTour);
Vue.use(AmAngularGauge);
// Vue.use(Vue2Dragula)
Vue.use(VueQuillEditor);
Vue.use(VueResource);
Vue.use(wysiwyg, {});
Vue.use(VueBreadcrumbs);
Vue.use(Notifications, { velocity });
Vue.use(fullscreen);
Vue.use(GlobalComponents);
Vue.use(ApplicationComponents);
Vue.use(VueVideoPlayer);
Vue.use(Croppa);
Vue.use(_);
Vue.use(HighchartsVue);
Vue.use(VueSignaturePad);
// Vue.use(VueCookies);
Vue.use(VueCookies, { expires: "7d" });
// Vue.use(helpers);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDHKMnJ-mwOvP7HxDGsN5E_pu_NnuMhWKw", // Add your here your google map api key
    },
});

Vue.use(globalFunctions);
Vue.use(applicationFunctions);

Charts(FusionCharts);
Widgets(FusionCharts);
PowerCharts(FusionCharts);
FusionTheme(FusionCharts);

FusionCharts.options.license({
    key: "yiF3aI-8rA4B8E2C4F6E4G3D3D3B4C8B4E6qg1jI4F2okgF-11hB4E3cufA4B4C2G5G4E3G3A1C8A6D4A3D3B4H3A33qhhD8B1B4hH4B3B2B-32C-22kA3C4E3uwfC5A2B2uomF1B3F1C7B5A4E5E3B4A3H4bddA5E4WD3hlcB5B1E4raB2JF2E1C-21D-16hE1G5D1B2C2D2A4A6D3E3F4H2H3C3v==",
    creditLabel: false,
});

Vue.use(VueFusionCharts, FusionCharts, Charts);

// set default config
Vue.$cookies.config("7d");

Vue.mixin({
    data() {
        return {
            base_api_url: AppConfig.baseApiUrl,
        };
    },
    computed: {
        ...mapState({
            current_user: (state) => state.auth.current_user,
        }),
        ...mapGetters(["$r", "validate_state", "user_is_dev"]),
        $bp() {
            this.$vuetify.breakpoint.smallScreen =
                this.$vuetify.breakpoint.smAndDown ||
                ((this.$vuetify.breakpoint.height + (this.$vuetify.breakpoint.mdOnly ? 100 : 0)) * 2 < this.$vuetify.breakpoint.width &&
                    !this.$vuetify.breakpoint.xlOnly &&
                    this.$vuetify.breakpoint.width < 1300);
            return this.$vuetify.breakpoint;
        },
        currUserField() {
            return (field) => {
                return this.current_user && field && this.current_user[field] ? this.current_user[field] : "";
            };
        },
        current_day() {
            return new Date().toLocaleDateString("fr-CA", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            }); // fr-CA locale to match YYYY-MM-DD format for datepicker component
        },
        current_time() {
            return new Date().toLocaleTimeString("en-US", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                hour12: false,
                hour: "numeric",
                minute: "numeric",
            });
        },
        dev_mode() {
            return AppConfig.env_mode === "development";
        },
    },
    methods: {
        // sets focus to the element which has desired ref defined
        setFocus(ref) {
            if (ref) {
                if (this.$refs[ref]) {
                    if (this.$refs[ref].$refs.input) {
                        setTimeout(() => {
                            this.$refs[ref].$refs.input.focus();
                        }, 200);
                    } else {
                        setTimeout(() => {
                            let obj = this.$refs[ref].$refs;
                            obj[Object.keys(obj)[0]].$refs.input.focus();
                        }, 200);
                    }
                } else {
                    throw new Error(`Ref missing or input is not displayed when focus is called on ref: ${ref}`);
                }
            }
        },
        // open/close dialogs based on model/status, focusing certain field if necessary
        control_dialog(dialog_model, status, focus) {
            this[dialog_model] = status;
            if (focus) {
                this.setFocus(focus);
            }
        },
        // if dialog_model is defined call function to open/focus on dialog
        // else call function defined as action, focusing if necessary (v-focus directive replaced setFocus function)
        // event: the object being passed to the method
        invokeMethod(event) {
            if (event.dialog_model) {
                this[event.action](event.dialog_model, event.status, event.focus);
            } else if (event.ref && event.action) {
                this.$refs[event.ref][event.action](); // if ref is included, call function located under that ref
            } else if (event.status) {
                this[event.action](event.status);
            } else if (event.params) {
                this[event.action].apply(this, event.params);
            } else {
                this[event.action]();
            }
            if (event.focus && !event.dialog_model) {
                this.setFocus(event.focus);
            }
        },
        // use to change a variables value on blur
        // object: the object the variable is under
        // variable: the name of the variable to change
        // value: the value that the variable is set to
        onBlur(e, object, variable, value) {
            if (e.target.value == "") {
                this.$set(this[object], variable, value);
            }
        },
        // use to change a variables value on focus
        // object: the object the variable is under
        // variable: the name of the variable to change
        // value: the value that the variable is set to
        onFocus(e, object, variable, value) {
            if (e.target.value == value) {
                this.$set(this[object], variable, null);
            }
        },
        // check the current users permissions to see if they can interact with the interface
        // takes in the current permission to be checked along with the company to check it with
        // if there is no company passed through it checks to see if the user has the perm for any one company
        check_permission(currentPermission, companyId) {
            //TODO: need to include logic for auth tokens
            //if there are no accounts for some reason, return no permission
            if (!this.current_user || (this.current_user.accounts || []).length == 0) return true; //TODO: temp: was 'false'
            //if its an employee give all permissions
            if ((companyId == null && companyId != undefined) || this.current_user.accounts[0].company_id == null) {
                return true;
            }
            //if no company is passed through
            if (!companyId) {
                let result = this.current_user.accounts.filter((account) => account.permissions.indexOf(currentPermission) != -1);
                return (result || []).length > 0;
            }
            //if a company is passed through
            for (let i = 0; i < this.current_user.accounts.length; i++) {
                if (this.current_user.accounts[i].company_id == companyId) {
                    return this.current_user.accounts[i].permissions.indexOf(currentPermission) > 0;
                } else if (companyId == null) {
                    return false;
                }
            }

            return false;
        },
        // check the current users permissions to see if they can interact with the interface
        hasPerm(permission = null) {
            if (permission && this.current_user && (this.current_user.global || []).length > 0) {
                return this.current_user.global.includes(permission);
            }

            return false;
        },
        hasLoginType(login_type = null) {
            if (login_type && this.current_user && this.current_user.slug) {
                return login_type.includes(this.current_user.slug);
            }
        },
        personHasLoginType(person = null, login_type = null) {
            if (login_type && person && person.slug) {
                return login_type.includes(person.slug);
            }
        },
        personDoesNotHasLoginType(person = null, login_type = null) {
            if (login_type && person && person.slug) {
                return !login_type.includes(person.slug);
            }
        },
        doesNotHaveLoginType(login_type = null) {
            if (login_type && this.current_user && this.current_user.slug) {
                return !login_type.includes(this.current_user.slug);
            }
        },
        isInternalUser() {
            let user_types = ["customer_support", "employee", "administrator", "developer"];

            if (this.current_user && this.current_user.slug) {
                return user_types.includes(this.current_user.slug);
            } else {
                return false;
            }
        },
        isJason(user) {
            if (user && user.user_id == 1) {
                return true;
            }
            return false;
        },
        isNotInternalUser() {
            let user_types = [
                "csr",
                "producer",
                "dispatcher",
                "technician",
                "driver",
                "dispenser_mgr",
                "d_acct_mgr",
                "v_acct_mgr",
                "customer",
                "distributor",
                "vendor",
                "customer_readonly",
            ];

            if (this.current_user && this.current_user.slug) {
                return user_types.includes(this.current_user.slug);
            } else {
                return false;
            }
        },
        setQuery(query, filter, default_filter) {
            if (query) {
                for (const param in default_filter) {
                    // for each filter on page, set it from query or unset if not in query
                    filter[param] = query[param] ? query[param] : default_filter[param];
                }
            }
        },
        filterTool: _.debounce(
            function (params, loader = true) {
                let filters = JSON.parse(JSON.stringify(params));
                delete filters.page_num; //remove page
                if (this.$bp.xs) {
                    // default is to keep menu open on search, if mobile it should get closed
                    store.commit("toggleFilterMenu", false);
                }
                this.$router.push({ name: this.$route.name, query: filters, params: { loader: loader, ...this.$route.params } });
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
        clearFilter: _.debounce(
            function () {
                store.commit("toggleFilterMenu", false);
                this.$router.push({ path: this.$route.path });
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
        prepareParams(filter, default_filter) {
            let params = {};
            for (const param in default_filter) {
                // for each filter on page, set it from query or unset if not in query
                let str = typeof filter[param] !== "undefined" ? filter[param] : "";
                if (typeof str === "string") {
                    str = str.trim();
                }
                if (typeof default_filter[param] !== "undefined" && str != default_filter[param] && str != null && str != "") {
                    params[param] = str;
                }
            }
            return params;
        },
        startLoader() {
            //store.commit("startLoader");
            store.dispatch("showLoader");
        },
        finishLoader(pg_refresh = false) {
            //store.commit("finishLoader");
            store.dispatch("hideLoader");
            if (pg_refresh) {
                this.createAlert("success", "page_refreshed", 3000);
            }
        },
        createAlert(type = "error", text = "notify_oops", alert_duration = 4000) {
            Vue.notify({
                group: "loggedIn",
                type: type,
                text: process.env.NODE_ENV === "production" ? this.$t(`lang.${text}`) : this.$t(`lang.${text}`), //'not ideal :-(',
                duration: alert_duration,
            });
        },
        updateFilterMenu(value) {
            store.commit("toggleFilterMenu", value);
        },
        filterClearInput(filter_key = null) {
            this.$nextTick(() => {
                if (filter_key) {
                    this.filter[filter_key] = this.default_filter[filter_key];
                } else {
                    for (let key in this.filter) {
                        if (typeof this.filter[key] == "undefined") {
                            this.filter[key] = this.default_filter[key];
                        }
                    }
                }
            });
        },
        focusOnError(formName = null) {
            this.$nextTick(() => {
                // three types of inputs to focus: select/text-field, <bc-phone-input> component, textarea
                // select/text-field:	".v-input.error--text:not(.d-none):not(.v-input--is-disabled) input:not(.ignore-focus):not(.country-selector__input)"
                // <bc-phone-input>: 		".vue-phone-number-input.number-error input:not(.ignore-focus):not(.country-selector__input)"
                // textarea: 			".v-input.error--text:not(.d-none):not(.v-input--is-disabled) textarea:not(.ignore-focus):not(.country-selector__input)"
                let activeDialog = document.querySelector(".v-dialog--active .v-form");
                let inputElement;
                if (activeDialog) {
                    // if an open dialog is found search through that form instead of page form
                    inputElement = activeDialog.querySelectorAll(
                        ".v-input.error--text:not(.d-none) input:not(.ignore-focus):not(.country-selector__input), .vue-phone-number-input.number-error input:not(.ignore-focus):not(.country-selector__input), .v-input.error--text:not(.d-none) textarea:not(.ignore-focus):not(.country-selector__input)"
                    );
                } else {
                    let form =
                        document.querySelector(".v-content .v-form:not(.ignore-form)") || document.querySelector(".session-content .v-form:not(.ignore-form)");
                    inputElement = form.querySelectorAll(
                        ".v-input.error--text:not(.d-none) input:not(.ignore-focus):not(.country-selector__input), .vue-phone-number-input.number-error input:not(.ignore-focus):not(.country-selector__input), .v-input.error--text:not(.d-none) textarea:not(.ignore-focus):not(.country-selector__input)"
                    );
                }
                let el = inputElement[0];
                if (el) {
                    setTimeout(() => {
                        el.focus();
                    }, 20);
                } else {
                    if (formName) console.error(`Form with ref of '${formName}' did not validate successfully but there is no visible error on the form.`);
                }
            });
            return false;
        },
        // expects local 'validate' variable
        // rules: string containing {form_name}.{field_name} or array of rules
        // current_id: allows for  rule 'is_unique' to work differently depending if on edit or add form
        //			   expects object containing { 'name_of_id_field': value_of_id_field }
        ifValid(rules = null, current_id = null) {
            if (rules == null)
                console.error(
                    "Missing specified rules.field or direct rules set in ifValid function. Double check rules.field or a set of rules (i.e. from global rules variable) is passed to function."
                );
            let rules_form = null;
            if (rules != null && typeof rules == "string") rules_form = _.get(this, `rules_${rules}`);
            // console.log(rules_form)
            let eval_rules = [];
            if (typeof this.validate_state != undefined && this.validate_state && rules) {
                if (typeof rules == "string") {
                    if (rules_form) {
                        // console.log(rules_form.rules)
                        eval_rules = this.evalRules(rules_form.rules || [], current_id);
                    } else {
                        eval_rules = this.evalRules("required");
                        console.error(`Rules not properly set up, '${rules}' did not evaluate to a rules object, default to required.`);
                    }
                } else {
                    eval_rules = rules;
                }
            }
            // console.log(eval_rules)
            return eval_rules;
        },
        evalRules(rules, current_id = null) {
            let eval_rules = [];
            if (!!rules) {
                let regex = /^(?<rule>\w+)(\[(?<param>[\w.,\-\|\\]+)\])?/;
                let split_rules = [];
                split_rules = rules.match(/[^|[]+(\[[^\]]+\])?/g);
                if (split_rules.includes("required")) {
                    // ensure required is always first rule checked
                    // depending on rules include type in 'require' message
                    let type = null;
                    if (rules.includes("numeric")) {
                        type = "number";
                    } else if (rules.includes("decimal")) {
                        type = "decimal";
                    }
                    eval_rules.push(...this.$r.required(split_rules.includes("trim"), type));
                }
                // console.log('START LOOPING ')
                split_rules.forEach((t) => {
                    if (t != "trim" && t != "required") {
                        let matches = t.match(regex);
                        // console.log('matches', matches)
                        if (matches && matches.groups && matches.groups.rule && this.$r[matches.groups.rule]) {
                            if (matches.groups.rule == "is_unique") {
                                // if rule is 'is_unique' grab array defined, or map array from array.value pair
                                let split_list = matches.groups.param.split(".");
                                matches.groups.param = [..._.get(this, split_list[0])];

                                if (Object.values(current_id)[0] > 0) {
                                    _.remove(matches.groups.param, function (p) {
                                        return p[Object.keys(current_id)[0]] == Object.values(current_id)[0];
                                    });
                                }

                                if (split_list[1] && matches.groups.param) {
                                    matches.groups.param = matches.groups.param.map((param) => {
                                        return param[split_list[1]].toLowerCase();
                                    });
                                }
                            } else {
                                // if param is a local variable, store the value and name in param object
                                let eval_params = _.get(this, matches.groups.param) !== undefined;
                                // console.log(matches.groups.param, eval_params, _.get(this, matches.groups.param))
                                if (eval_params) {
                                    let prep_obj = {};
                                    prep_obj.name = this.$t(
                                        `lang.${(matches.groups.param || "").split(".")[(matches.groups.param || "").split(".").length - 1]}`
                                    );
                                    prep_obj.value = _.get(this, matches.groups.param);
                                    matches.groups.param = prep_obj;
                                }
                            }
                            // console.log('HERE', this.$r[matches.groups.rule](matches.groups.param))
                            eval_rules.push(...this.$r[matches.groups.rule](matches.groups.param));
                        }
                    }
                });
            }
            // console.log(eval_rules)
            return eval_rules;
        },
        showCounter(field, max, offsetValue = 6) {
            let rules_form = null;
            if (max != null && typeof max == "string") rules_form = _.get(this, `rules_${max}`);
            let rules_max = null;
            rules_max = rules_form && rules_form.max_len ? rules_form.max_len : max || null;
            if (rules_max == null) {
                console.error("Missing rules object or max number for showCounter function to work correctly");
                return false;
            }
            offsetValue = !!offsetValue ? offsetValue : 6;
            if (offsetValue == 6 && rules_max <= 100) offsetValue = 0;
            let offset = offsetValue;
            return !!rules_max ? (rules_max - (field || "").length < 0 ? rules_max : rules_max - (field || "").length < offset) : false;
        },
        validateForm(formName = null) {
            if (formName) {
                return this.$refs[formName].validate() || this.focusOnError(formName);
            } else {
                console.error("Missing specified form name when calling validateForm function.");
                return false;
            }
        },
        // assign values from one object to the other, restoring default value if data is empty
        // form: object in local component that will be passed to api 'post'
        // data: the object to be displayed or null to reset to default
        // rules: the full rules object for this form
        assignObj(form, data, rules) {
            if (data) {
                for (const key in data) if (key in form) form[key] = data[key];
            } else {
                for (const key in form) if (key in rules) form[key] = rules[key].default_value == "null" ? null : rules[key].default_value;
            }
        },
        assignObj2(data, rules) {
            const form = {};
            if (data) {
                for (const key in data) {
                    if (Array.isArray(data[key])) {
                        form[key] = [];

                        for (const arraykey in data[key]) {
                            form[key][arraykey] = {};

                            for (const detail_field in data[key][arraykey]) {
                                form[key][arraykey][detail_field] = data[key][arraykey][detail_field];
                            }
                        }
                    } else {
                        form[key] = data[key];
                    }
                }
            } else {
                for (const key in form) if (key in rules) form[key] = rules[key].default_value == "null" ? null : rules[key].default_value;
            }
            return form;
        },
        prepForm(data, rules) {
            const form = {};

            if (data) {
                for (const key in data) {
                    if (key in rules) {
                        // if data is array
                        if (Array.isArray(data[key])) {
                            form[key] = [];
                            const detail_rules = rules[key];
                            for (const arraykey in data[key]) {
                                form[key][arraykey] = {};

                                for (const detail_field in data[key][arraykey]) {
                                    if (detail_field in detail_rules) form[key][arraykey][detail_field] = data[key][arraykey][detail_field];
                                }
                            }
                        } else {
                            // regular field
                            form[key] = data[key];
                        }
                    }
                }
            } else {
                for (const key in form) {
                    if (key in rules) form[key] = rules[key].default_value == "null" ? null : rules[key].default_value;
                }
            }

            return form;
        },
        countDecimals(a) {
            if (a === null || !isFinite(a)) return 0;
            var e = 1,
                p = 0;
            while (Math.round(a * e) / e !== a && p < 10) {
                e *= 10;
                p++;
            }
            return p;
        },
        goBackPage() {
            let lastRoute = localStorage.getItem("lastRoute");
            this.$nextTick(() => {
                if (lastRoute.indexOf("/session/login") > -1 && this.current_user) {
                    this.$router.push({ name: "dashboard", replace: true });
                } else {
                    this.$router.go(-1);
                }
            });
        },
    },
});

// filters
Vue.filter("capitalize", function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

// ellipses text if longer than amount
Vue.filter("shrink_text", function (value, amount) {
    //console.log(value);
    if (!value) return "";
    let trimmedVal = value.slice(0, amount).trim();
    if (value.length < amount) {
        return trimmedVal;
    } else {
        return trimmedVal.concat("...");
    }
});

// cuts off the givin amount of digits from a int
Vue.filter("chop_number", function (value, amount) {
    if (!value) return "";
    return parseFloat(value) / Math.pow(10, parseFloat(amount));
});

// adds commas to a number where applicable
Vue.filter("with_commas", function (num) {
    if (!num) return "";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
// adds commas to a number where applicable
Vue.filter("start_case", function (text) {
    if (!text) return "";
    return _.startCase(text);
});
// sets focus to element the v-focus directive is placed
// value - the variable controlling visability of the dialog/menu the element is contained
Vue.directive("focus", {
    inserted: function (el, binding) {
        let value = binding.value;
        let oldValue = binding.oldValue;
        // if(value == true && binding.oldValue == false) console.log('focus - inserted', binding, value); //DEBUG ONLY
        if ((value == undefined || (value && value != oldValue)) && document.body.clientWidth > 1300) {
            setTimeout(() => {
                let childData =
                    el.querySelectorAll("input:not(.ignore-focus):not(.country-selector__input)")[0] ||
                    el.querySelectorAll("textarea:not(.ignore-focus):not(.country-selector__input)")[0];
                childData.focus();
            }, 100);
        }
    },
    update: function (el, binding) {
        let value = binding.value;
        let oldValue = binding.oldValue;
        // if(value == true && binding.oldValue == false) console.log('focus - update', binding, value); //DEBUG ONLY
        if (value && value != oldValue && document.body.clientWidth > 1300) {
            setTimeout(() => {
                let childData =
                    el.querySelectorAll("input:not(.ignore-focus):not(.country-selector__input)")[0] ||
                    el.querySelectorAll("textarea:not(.ignore-focus):not(.country-selector__input)")[0];
                childData.focus();
            }, 100);
        }
    },
});

Vue.directive("click-overlay", {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if ($(event.target).hasClass("v-overlay")) {
                let activeDialog = document.querySelector(".v-dialog--active");
                // check that click was outside the el and its children
                if (!(el == event.target || el.contains(event.target)) && !activeDialog) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

Vue.directive("cancel-delete-confirm", {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if ($(event.target).hasClass("v-overlay")) {
                let activeDialog = document.querySelector(".v-dialog--active");
                // check that click was outside the el and its children
                if (!(el == event.target || el.contains(event.target)) && activeDialog) {
                    // and if it did, call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

Vue.directive("readonly-click", {
    bind(el, binding) {
        const value = binding.value;
        if (value != undefined) {
            if (value) {
                var allElements = el.querySelectorAll("*");
                allElements.forEach(function (element) {
                    // Apply your desired styles to each element
                    element.style.pointerEvents = "none";
                    // Add more styles as needed
                });
            } else {
                var allElements = el.querySelectorAll("*");
                allElements.forEach(function (element) {
                    // Apply your desired styles to each element
                    element.style.pointerEvents = "auto";
                    // Add more styles as needed
                });
                el.style.cursor = "default";
            }
        } else {
            var allElements = el.querySelectorAll("*");
            allElements.forEach(function (element) {
                // Apply your desired styles to each element
                element.style.pointerEvents = "none";
                // Add more styles as needed
            });
        }
    },
    unbind(el) {
        var allElements = el.querySelectorAll("*");
        allElements.forEach(function (element) {
            // Apply your desired styles to each element
            element.style.pointerEvents = "auto";
            // Add more styles as needed
        });
        el.style.cursor = "default";
    },
});

Vue.directive("sortable-data-table", {
    bind(el, binding, vnode) {
        const options = {
            animation: 150,
            handle: ".drag-handle",
            onSort: function (event) {
                vnode.child.$emit("sorted", event);
            },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
    },
});
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: store.getters.selectedLocale.locale, // set locale
    messages, // set locale messages
});
/* eslint-disable no-new */
//mixins: [mixin],
export default new Vue({
    store,
    i18n,
    router,
    render: (h) => h(App),
    components: { App },
}).$mount("#app");
